import ManufacturerList from "./ManufacturerList";
import ManufacturerCreate from "./ManufacturerCreate";
import ManufacturerEdit from "./ManufacturerEdit";


const manufacturers = {
  list: ManufacturerList,
  create: ManufacturerCreate,
  edit: ManufacturerEdit,
};

export default manufacturers;